exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".imitate-panel[data-v-750bb968]{position:fixed;top:0;left:0;width:300px;background-color:#212529;color:#fff;z-index:9999;border-bottom-right-radius:.25rem;box-shadow:0 .75rem 1.5rem rgba(18,38,63,.03);overflow-wrap:anywhere}", ""]);

// exports
